const fixDutyFine = {
  DefiniteTime: {
    zh: '定责时间',
    en: 'Definite Time',
    pu: 'Tempo de Responsabilidade'
  },
  DefiniteType: {
    zh: '定责类型',
    en: 'Definite Type',
    pu: 'Tipo de ocorrência'
  },
  StolenOrRobbed: {
    zh: '被抢或被盗',
    en: 'Stolen or Robbed',
    pu: 'Pacote roubado/furtado'
  },
  ComplaintWorkOrderTimeoutNotReplied: {
    zh: '投诉工单-超时未回复',
    en: 'Complaint work order - Timeout not replied',
    pu: 'Acareação - Sem resposta dentro do prazo'
  },
  SocialMediaUpgradeComplaint: {
    zh: '社媒升级投诉',
    en: 'Social media upgrade complaint',
    pu: 'Reclamação em redes sociais'
  },
  PODNotQualified: {
    zh: 'POD不合格',
    en: 'POD not qualified',
    pu: 'POD não qualificado'
  },
  DefiniteLink: {
    zh: '定责环节',
    en: 'Definite link',
    pu: 'Etapas'
  },
  ResponsibleParty: {
    zh: '责任方',
    en: 'Responsible party',
    pu: 'Parte responsável'
  },
  ModifyResponsibleBranch: {
    zh: '修改责任网点',
    en: 'Modify responsible branch',
    pu: 'Modificar filial responsável'
  },
  Item: {
    zh: '项',
    en: 'Item',
    pu: 'itens'
  },
  Damage: {
    zh: '破损',
    en: 'Damage',
    pu: 'Pacote avariado'
  },
  PODIrregular: {
    zh: 'POD不规范',
    en: 'POD irregular',
    pu: 'POD inválido'
  },
  ResponsibleLink: {
    zh: '责任环节',
    en: 'Responsible link',
    pu: 'Link de Responsabilidade'
  },
  EstimatedPenaltyAmount: {
    zh: '预计扣罚金额',
    en: 'Estimated penalty amount',
    pu: 'Valor estimado de multa'
  },
  LatestTrackingBranch: {
    zh: '最新轨迹网点',
    en: 'Latest tracking branch',
    pu: 'Último ponto de rastreio'
  },
  SecondaryNewTrackingTime: {
    zh: '次新轨迹时间',
    en: 'Secondary new tracking time',
    pu: 'Penúltimo tempo de rastreio'
  },
  SecondaryNewTrackingContent: {
    zh: '次新轨迹内容',
    en: 'Secondary new tracking content',
    pu: 'Penúltimo conteúdo de rastreio'
  },
  SecondaryNewTrackingBranch: {
    zh: '次新轨迹网点',
    en: 'Secondary new tracking branch',
    pu: 'Penúltimo ponto de rastreio'
  },
  ResponsibleBranch: {
    zh: '责任网点',
    en: 'Responsible branch',
    pu: 'Ponto responsável'
  },
  TotalModification: {
    zh: '总共修改',
    en: 'Total modification',
    pu: 'Total de modificação'
  },
  ModificationFailedOrderNumber: {
    zh: '修改失败单号',
    en: 'Modification failed order number',
    pu: 'Número de ordem de modificação falhou'
  },
  Only2000PiecesImport: {
    zh: '每次仅导入2000条',
    en: 'Only 2000 pieces are imported at a time',
    pu: 'Importar apenas 2000 itens de cada vez'
  },
  ImportFailedOrderNumber: {
    zh: '导入失败单号',
    en: 'Import failed order number',
    pu: 'Número de ordem de importação falhou'
  },
  frontEndCollection: {
    zh: '前端揽收',
    en: 'Front-end Collection',
    pu: 'Coleta no Front-end'
  },
  hubOperation: {
    zh: 'HUB操作',
    en: 'HUB Operation',
    pu: 'Operação no HUB'
  },
  collectionTransport: {
    zh: '揽收运输',
    en: 'Collection Transport',
    pu: 'Transporte de Coleta'
  },
  glpUnloading: {
    zh: 'GLP卸车',
    en: 'GLP Unloading',
    pu: 'Descarregamento GLP'
  },
  delayedProcess: {
    zh: '延误的流程',
    en: 'Delayed Process',
    pu: 'Processo Atrasado'
  },
  estimatedOperationDuration: {
    zh: '预计操作时长(H)',
    en: 'Estimated Operation Duration(H)',
    pu: 'Duração Estimada da Operação(H)'
  },
  actualOperationDuration: {
    zh: '实际操作时长(H)',
    en: 'Actual Operation Duration(H)',
    pu: 'Duração Real da Operação(H)'
  },
  delayDuration: {
    zh: '延误时长(H)',
    en: 'Delay Duration(H)',
    pu: 'Duração do Atraso(H)'
  },
  DefinitePerson: {
    zh: '定责人',
    en: 'Definite person',
    pu: 'Pessoa de Responsabilidade'
  },
  selectTimeRange: {
    zh: '请选择查询时间范围',
    en: 'Please select the query time range',
    pu: 'Por favor selecione o intervalo de tempo da consulta'
  },
  modifyResponsibility: {
    zh: '修改定责',
    en: 'Modify Responsibility',
    pu: 'Modificar Responsabilidade'
  },
  selectResponsibleParty: {
    zh: '请选择责任方',
    en: 'Please select the responsible party',
    pu: 'Por favor selecione a parte responsável'
  },
  selectBeforeModify: {
    zh: '请先选择,再修改',
    en: 'Please select first, then modify',
    pu: 'Por favor selecione primeiro, depois modifique'
  },
  trunkLine: {
    zh: '干线',
    en: 'Trunk Line',
    pu: 'Linha Tronco'
  },
  reportTime: {
    zh: '上报时间',
    en: 'Report Time',
    pu: 'Hora do Relatório'
  },
  approvalTime: {
    zh: '审批时间',
    en: 'Approval Time',
    pu: 'Hora de Aprovação'
  },
  eventType: {
    zh: '事件类型',
    en: 'Event Type',
    pu: 'Tipo de Evento'
  },
  abnormalEvent: {
    zh: '异常事件',
    en: 'Abnormal Event',
    pu: 'Evento Anormal'
  },
  theftEvent: {
    zh: '盗抢事件',
    en: 'Theft/Robbery Event',
    pu: 'Evento de Roubo/Furto'
  },
  abnormalityType: {
    zh: '异常类型',
    en: 'Abnormality Type',
    pu: 'Tipo de Anormalidade'
  },
  pendingApproval: {
    zh: '待审批',
    en: 'Pending Approval',
    pu: 'Aprovação Pendente'
  },
  reportingRegion: {
    zh: '上报大区',
    en: 'Reporting Region',
    pu: 'Região de Relatório'
  },
  reportingPersonnel: {
    zh: '上报人员',
    en: 'Reporting Personnel',
    pu: 'Pessoal de Relatório'
  },
  reportedEvent: {
    zh: '上报事件',
    en: 'Reported Event',
    pu: 'Evento Reportado'
  },
  reportingTime: {
    zh: '上报时间',
    en: 'Reporting Time',
    pu: 'Hora de Relatório'
  },
  eventCategory: {
    zh: '事件类型',
    en: 'Event Category',
    pu: 'Categoria de Evento'
  },
  maxExportLimit: {
    zh: '单次最多导出1000个单号',
    en: 'Maximum 1000 tracking numbers per export',
    pu: 'Máximo de 1000 números de rastreamento por exportação'
  },
  abnormalityLevel: {
    zh: '异常等级',
    en: 'Abnormality Level',
    pu: 'Nível de Anormalidade'
  },
  affectedPackageCount: {
    zh: '影响包裹数量',
    en: 'Affected Package Count',
    pu: 'Contagem de Pacotes Afetados'
  },
  estimatedFinancialLoss: {
    zh: '预估资金损失(R$)',
    en: 'Estimated Financial Loss (R$)',
    pu: 'Perda Financeira Estimada (R$)'
  },
  casualtyCount: {
    zh: '伤亡人员数量',
    en: 'Casualty Count',
    pu: 'Contagem de Vítimas'
  },
  approver: {
    zh: '审批人',
    en: 'Approver',
    pu: 'Aprovador'
  },
  abnormalityDescription: {
    zh: '异常事件描述',
    en: 'Abnormality Description',
    pu: 'Descrição da Anormalidade'
  },
  hasPoliceReceipt: {
    zh: '是否有报警回执?',
    en: 'Has Police Receipt?',
    pu: 'Possui Recibo Policial?'
  },
  hasMDFE: {
    zh: '是否开具MDFE?',
    en: 'Has MDFE Issued?',
    pu: 'Foi Emitido MDFE?'
  },
  hasElectronicLock: {
    zh: '是否有电子锁?',
    en: 'Has Electronic Lock?',
    pu: 'Possui Fechadura Eletrônica?'
  },
  photos: {
    zh: '照片',
    en: 'Photos',
    pu: 'Fotos'
  },
  excludeFromTimeliness: {
    zh: '是否剔除时效?',
    en: 'Exclude from Timeliness?',
    pu: 'Excluir do Prazo?'
  },
  estimatedLossAmount: {
    zh: '预估损失金额',
    en: 'Estimated Loss Amount',
    pu: 'Valor Estimado da Perda'
  },
  eventApproval: {
    zh: '事件审批',
    en: 'Event Approval',
    pu: 'Aprovação de Evento'
  },
  viewDetails: {
    zh: '查看详情',
    en: 'View Details',
    pu: 'Ver Detalhes'
  },
  affectedPackageDetails: {
    zh: '影响包裹明细',
    en: 'Affected Package Details',
    pu: 'Detalhes dos Pacotes Afetados'
  },
  selectExcludeTimeliness: {
    zh: '请选择是否剔除时效',
    en: 'Please select whether to exclude from timeliness',
    pu: 'Por favor selecione se deseja excluir do prazo'
  },
  uploadImageLimit: {
    zh: '最多可上传6张图片.仅支持上传格式为(jpg、jpeg、png、gif)',
    en: 'Maximum 6 images can be uploaded. Only supports (jpg, jpeg, png, gif) formats',
    pu: 'Máximo de 6 imagens podem ser carregadas. Suporta apenas formatos (jpg, jpeg, png, gif)'
  },
  high: {
    zh: '高',
    en: 'High',
    pu: 'Alto'
  },
  medium: {
    zh: '中',
    en: 'Medium',
    pu: 'Médio'
  },
  low: {
    zh: '低',
    en: 'Low',
    pu: 'Baixo'
  },
  addPhotos: {
    zh: '添加照片',
    en: 'Add Photos',
    pu: 'Adicionar imagens'
  },
  uploadImages: {
    zh: '请上传图片',
    en: 'Please upload images',
    pu: 'Por favor carregue imagens'
  },
  imageUploadFailed: {
    zh: '上传图片失败',
    en: 'Image upload failed',
    pu: 'Falha no carregamento da imagem'
  },
  formatFile: {
    zh: '请上传图片格式的文件(jpg、jpeg、png、gif)',
    en: '',
    pu: 'Faca um upload de documento na forma de foto(jpg, jpeg, png, gif)'
  },
  max50ExportLimit: {
    zh: '单次最多导出500000个单号',
    en: 'Maximum 500000 tracking numbers per export',
    pu: 'Máximo de 500000 números de rastreamento por exportação'
  },
  searchMax10w: {
    zh: '单次查询最多10万条，已截取前10万条',
    en: '',
    pu: 'Máximo de 2.000 entradas para uma única consulta, as primeiras 2.000 entradas foram interceptadas'
  },
  // ===== 扣罚确认单 / 扣罚对账单 (DeductionConfirmationForm) =====
  pleaseSelect: {
    zh: '请选择',
    en: 'Please select',
    pu: 'Selecione'
  },
  region: {
    zh: '大区',
    en: 'Region',
    pu: 'Região'
  },
  allRegions: {
    zh: '全部大区',
    en: 'All regions',
    pu: 'Todas as regiões'
  },
  penaltyType: {
    zh: '扣罚类型',
    en: 'Penalty type',
    pu: 'Tipo de penalidade'
  },
  processStatus: {
    zh: '处理状态',
    en: 'Processing status',
    pu: 'Status de processamento'
  },
  waybillNumber: {
    zh: '运单号',
    en: 'Waybill number',
    pu: 'Número do conhecimento'
  },
  waybillPlaceholder: {
    zh: '请输入完整单号，最多2000行',
    en: 'Enter the complete waybill number, up to 2000 lines',
    pu: 'Insira o número completo, no máximo 2000 linhas'
  },
  query: {
    zh: '查询',
    en: 'Query',
    pu: 'Consultar'
  },
  reset: {
    zh: '重置',
    en: 'Reset',
    pu: 'Redefinir'
  },
  regionPenaltySummary: {
    zh: '大区扣罚类型汇总',
    en: 'Regional penalty type summary',
    pu: 'Resumo de tipos de penalidade por região'
  },
  summaryTip: {
    zh: '点击确认缺失-超时退回、待处理，跳转至扣罚单号明细页面',
    en: 'Click Confirmed lost / Timeout return / Pending to view the penalty waybill details',
    pu: 'Clique em Perda confirmada / Devolução por atraso / Pendente para ver os detalhes'
  },
  confirmedLost: {
    zh: '确认丢失',
    en: 'Confirmed lost',
    pu: 'Perda confirmada'
  },
  timeoutNoClosure: {
    zh: '超时未闭环',
    en: 'Timeout without closure',
    pu: 'Tempo excedido sem encerramento'
  },
  complaintWorkOrder: {
    zh: '投诉工单',
    en: 'Complaint work order',
    pu: 'Ordem de reclamação'
  },
  timeoutReturn: {
    zh: '超时退件',
    en: 'Timeout return',
    pu: 'Devolução por atraso'
  },
  acceptedAmount: {
    zh: '已认罚金额',
    en: 'Accepted penalty amount',
    pu: 'Valor de penalidade aceito'
  },
  pending: {
    zh: '待处理',
    en: 'Pending',
    pu: 'Pendente'
  },
  completionRate: {
    zh: '完成率',
    en: 'Completion rate',
    pu: 'Taxa de conclusão'
  },
  allStatus: {
    zh: '全部状态',
    en: 'All statuses',
    pu: 'Todos os status'
  },
  accepted: {
    zh: '已认罚',
    en: 'Accepted',
    pu: 'Aceito'
  },
  pendingReview: {
    zh: '待复核',
    en: 'Pending review',
    pu: 'Revisão pendente'
  },
  exempted: {
    zh: '已免责',
    en: 'Exempted',
    pu: 'Isento'
  },
  maintainOriginal: {
    zh: '维持原定责',
    en: 'Maintain original responsibility',
    pu: 'Manter responsabilidade original'
  },
  totalResponsibilityTickets: {
    zh: '本期定责总票数',
    en: 'Total responsibility tickets this period',
    pu: 'Total de tickets de responsabilidade neste período'
  },
  comparedLastPeriod: {
    zh: '较上期',
    en: 'vs last period',
    pu: 'vs período anterior'
  },
  pleaseCompleteBeforeDeadline: {
    zh: '请在本期截止前完成',
    en: 'Please complete before the current period deadline',
    pu: 'Conclua antes do prazo deste período'
  },
  ratio: {
    zh: '占比',
    en: 'Ratio',
    pu: 'Proporção'
  },
  appealed: {
    zh: '已申诉',
    en: 'Appealed',
    pu: 'Contestado'
  },
  processingCompletionRate: {
    zh: '处理完成率',
    en: 'Processing completion rate',
    pu: 'Taxa de conclusão do processamento'
  },
  targetGte95: {
    zh: '目标 ≥ 95%',
    en: 'Target ≥ 95%',
    pu: 'Meta ≥ 95%'
  },
  pendingHeadquartersReview: {
    zh: '待总部复核',
    en: 'Pending headquarters review',
    pu: 'Revisão pendente da matriz'
  },
  from: {
    zh: '来自',
    en: 'From',
    pu: 'De'
  },
  regionsUnit: {
    zh: '个大区',
    en: 'regions',
    pu: 'regiões'
  },
  reviewed: {
    zh: '已复核',
    en: 'Reviewed',
    pu: 'Revisado'
  },
  periodCompletionRate: {
    zh: '本期完成率',
    en: 'Completion rate this period',
    pu: 'Taxa de conclusão do período'
  },
  determinedExempted: {
    zh: '判定免责',
    en: 'Determined exempt',
    pu: 'Isenção determinada'
  },
  exemptionRate: {
    zh: '免责率',
    en: 'Exemption rate',
    pu: 'Taxa de isenção'
  },
  maintainResponsibility: {
    zh: '维持定责',
    en: 'Maintain responsibility',
    pu: 'Manter responsabilidade'
  },
  maintenanceRate: {
    zh: '维持率',
    en: 'Maintenance rate',
    pu: 'Taxa de manutenção'
  },
  avgReviewDuration: {
    zh: '平均复核时长',
    en: 'Average review duration',
    pu: 'Duração média de revisão'
  },
  daysUnit: {
    zh: '天',
    en: 'days',
    pu: 'dias'
  },
  targetLte2Days: {
    zh: '目标 ≤ 2天',
    en: 'Target ≤ 2 days',
    pu: 'Meta ≤ 2 dias'
  },
  ticketsUnit: {
    zh: '票',
    en: 'tickets',
    pu: 'tickets'
  },
  allTypes: {
    zh: '全部类型',
    en: 'All types',
    pu: 'Todos os tipos'
  },
  // ===== 扣罚类型明细页 (DetailList) =====
  penaltyStatementBreadcrumb: {
    zh: '扣罚对账单 / 扣罚类型明细',
    en: 'Penalty statement / Penalty type details',
    pu: 'Fatura de penalidade / Detalhes do tipo de penalidade'
  },
  waybillDetail: {
    zh: '单号明细',
    en: 'Waybill details',
    pu: 'Detalhes do conhecimento'
  },
  permissionTip: {
    zh: '权限仅显示处理明细',
    en: 'Only processing details are shown per your permission',
    pu: 'Apenas os detalhes de processamento são exibidos conforme sua permissão'
  },
  backToSummary: {
    zh: '返回汇总',
    en: 'Back to summary',
    pu: 'Voltar ao resumo'
  },
  exportDetail: {
    zh: '导出明细',
    en: 'Export details',
    pu: 'Exportar detalhes'
  },
  searchWaybill: {
    zh: '搜索运单号',
    en: 'Search waybill number',
    pu: 'Pesquisar número do conhecimento'
  },
  allPenaltyTypes: {
    zh: '全部扣罚类型',
    en: 'All penalty types',
    pu: 'Todos os tipos de penalidade'
  },
  allProcessStatus: {
    zh: '全部处理状态',
    en: 'All processing statuses',
    pu: 'Todos os status de processamento'
  },
  selectedHint: {
    zh: '已选 {count} 项，请先勾选需要处理的记录',
    en: '{count} selected, please tick the records to process first',
    pu: '{count} selecionados, marque primeiro os registros a processar'
  },
  export: {
    zh: '导出',
    en: 'Export',
    pu: 'Exportar'
  },
  batchProcess: {
    zh: '批量处理',
    en: 'Batch process',
    pu: 'Processar em lote'
  },
  batchFinalDetermination: {
    zh: '批量最终定责',
    en: 'Batch final determination',
    pu: 'Determinação final em lote'
  },
  site: {
    zh: '网点',
    en: 'Site',
    pu: 'Ponto'
  },
  latestTrackContent: {
    zh: '最新轨迹内容',
    en: 'Latest tracking content',
    pu: 'Último conteúdo de rastreio'
  },
  latestTrackTime: {
    zh: '最新轨迹时间',
    en: 'Latest tracking time',
    pu: 'Último tempo de rastreio'
  },
  penaltyAmount: {
    zh: '扣罚金额',
    en: 'Penalty amount',
    pu: 'Valor da penalidade'
  },
  appealReason: {
    zh: '申诉原因',
    en: 'Appeal reason',
    pu: 'Motivo da contestação'
  },
  finalReviewOpinion: {
    zh: '最终审核意见',
    en: 'Final review opinion',
    pu: 'Parecer final da revisão'
  },
  operation: {
    zh: '操作',
    en: 'Operation',
    pu: 'Operação'
  },
  process: {
    zh: '处理',
    en: 'Process',
    pu: 'Processar'
  },
  finalDetermination: {
    zh: '最终定责',
    en: 'Final determination',
    pu: 'Determinação final'
  },
  view: {
    zh: '查看',
    en: 'View',
    pu: 'Ver'
  },
  all: {
    zh: '全部',
    en: 'All',
    pu: 'Todos'
  },
  paginationTip: {
    zh: '对账单生成后锁定数据；总部维护后形成实际计费。',
    en: 'Data is locked once the statement is generated; actual billing is formed after headquarters maintenance.',
    pu: 'Os dados são bloqueados após a geração da fatura; a cobrança real é formada após a manutenção da matriz.'
  },
  selectPendingReviewRows: {
    zh: '请先勾选「待复核」状态的记录',
    en: 'Please tick records in Pending review status first',
    pu: 'Marque primeiro os registros com status Revisão pendente'
  },
  selectPendingRows: {
    zh: '请先勾选「待处理」状态的记录',
    en: 'Please tick records in Pending status first',
    pu: 'Marque primeiro os registros com status Pendente'
  },
  // ===== 处理扣罚弹窗 (ProcessPenaltyDialog) =====
  processPenaltyTitle: {
    zh: '处理扣罚',
    en: 'Process penalty',
    pu: 'Processar penalidade'
  },
  selected: {
    zh: '选中',
    en: 'Selected',
    pu: 'Selecionado'
  },
  accept: {
    zh: '认罚',
    en: 'Accept',
    pu: 'Aceitar'
  },
  appeal: {
    zh: '申诉',
    en: 'Appeal',
    pu: 'Contestar'
  },
  appealReasonPlaceholder: {
    zh: '申诉时请填写原因',
    en: 'Please enter the reason for the appeal',
    pu: 'Informe o motivo da contestação'
  },
  acceptReasonPlaceholder: {
    zh: '请填写认罚说明（选填）',
    en: 'Enter the acceptance note (optional)',
    pu: 'Informe a observação de aceite (opcional)'
  },
  cancel: {
    zh: '取消',
    en: 'Cancel',
    pu: 'Cancelar'
  },
  confirmSubmit: {
    zh: '确认提交',
    en: 'Confirm submit',
    pu: 'Confirmar envio'
  },
  selectProcessRecords: {
    zh: '请选择需要处理的记录',
    en: 'Please select the records to process',
    pu: 'Selecione os registros a processar'
  },
  appealReasonRequired: {
    zh: '申诉时必须填写原因',
    en: 'The reason is required when appealing',
    pu: 'O motivo é obrigatório ao contestar'
  },
  invalidWaybillId: {
    zh: '未获取到有效的运单ID，无法提交',
    en: 'No valid waybill ID found, cannot submit',
    pu: 'Nenhum ID de conhecimento válido encontrado, não é possível enviar'
  },
  processSuccess: {
    zh: '处理成功',
    en: 'Processed successfully',
    pu: 'Processado com sucesso'
  },
  processFailed: {
    zh: '处理失败',
    en: 'Processing failed',
    pu: 'Falha no processamento'
  },
  networkError: {
    zh: '网络异常，请稍后重试',
    en: 'Network error, please try again later',
    pu: 'Erro de rede, tente novamente mais tarde'
  },
  // ===== 最终定责弹窗 (FinalDeterminationDialog) =====
  exempt: {
    zh: '免责',
    en: 'Exempt',
    pu: 'Isentar'
  },
  reviewOpinion: {
    zh: '审核意见',
    en: 'Review opinion',
    pu: 'Parecer da revisão'
  },
  maintainOpinionPlaceholder: {
    zh: '维持原定责时必须填写判定依据',
    en: 'The basis is required when maintaining the original responsibility',
    pu: 'A base é obrigatória ao manter a responsabilidade original'
  },
  reviewOpinionPlaceholder: {
    zh: '填写判定依据',
    en: 'Enter the basis',
    pu: 'Informe a base'
  },
  confirmDetermination: {
    zh: '确认定责',
    en: 'Confirm determination',
    pu: 'Confirmar determinação'
  },
  selectDeterminationRecords: {
    zh: '请选择需要定责的记录',
    en: 'Please select the records to determine',
    pu: 'Selecione os registros a determinar'
  },
  maintainOpinionRequired: {
    zh: '维持原定责时必须填写审核意见',
    en: 'The review opinion is required when maintaining the original responsibility',
    pu: 'O parecer é obrigatório ao manter a responsabilidade original'
  },
  determinationSuccess: {
    zh: '定责成功',
    en: 'Determined successfully',
    pu: 'Determinado com sucesso'
  },
  determinationFailed: {
    zh: '定责失败',
    en: 'Determination failed',
    pu: 'Falha na determinação'
  },
  // ===== 处理记录抽屉 (recordDrawer) =====
  processRecord: {
    zh: '处理记录',
    en: 'Processing records',
    pu: 'Registros de processamento'
  },
  currentStatus: {
    zh: '当前状态',
    en: 'Current status',
    pu: 'Status atual'
  },
  operatorLabel: {
    zh: '操作人：',
    en: 'Operator: ',
    pu: 'Operador: '
  },
  operationResultLabel: {
    zh: '操作结果：',
    en: 'Operation result: ',
    pu: 'Resultado da operação: '
  }
};
export { fixDutyFine };
